import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Icon from './Icon';
import { Caption } from './Typography';
import { Button } from './Button';
import { colorTextAdditional, colorBorder, colorHover } from '../theme/palette';

const FilePreview = ({
  file,
  onRemove,
  onDownload,
  showRemove = true,
  compact = false,
  ...props
}) => {
  const getFileIcon = fileName => {
    const extension = fileName.toLowerCase().substring(fileName.lastIndexOf('.'));

    switch (extension) {
      case '.pdf':
        return 'file-pdf';

      case '.doc':
      case '.docx':
        return 'file-word';

      case '.xls':
      case '.xlsx':
        return 'file-excel';

      case '.ppt':
      case '.pptx':
        return 'file-powerpoint';

      case '.txt':
        return 'file-text';

      case '.zip':
      case '.rar':
        return 'file-archive';

      case '.jpg':
      case '.jpeg':
      case '.png':
      case '.gif':
      case '.bmp':
        return 'file-image';

      default:
        return 'file';
    }
  };

  const formatFileSize = bytes => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  const handleRemove = e => {
    e.stopPropagation();

    if (onRemove) {
      onRemove(file);
    }
  };

  const handleClick = () => {
    if (onDownload) {
      onDownload(file);
    }
  }; // Suporta tanto objetos com .file quanto objetos diretos


  const fileName = file.name || file.NomeOriginal || file.nomeOriginal;
  const fileSize = file.file?.size || file.Tamanho || file.tamanho || 0;
  return <FilePreviewContainer compact={compact} onClick={onDownload ? handleClick : undefined} clickable={!!onDownload} {...props}>
      <div className="file-info">
        <Icon name={getFileIcon(fileName)} size={16} />
        <span>{fileName}</span>
        <Caption style={{
        color: colorTextAdditional
      }}>
          {formatFileSize(fileSize)}
        </Caption>
      </div>
      {showRemove && onRemove && <Button variant="outline-danger" size="sm" onClick={handleRemove}>
          <Icon name="delete" size={14} />
        </Button>}
    </FilePreviewContainer>;
};

FilePreview.propTypes = {
  file: PropTypes.oneOfType([PropTypes.shape({
    name: PropTypes.string,
    file: PropTypes.shape({
      size: PropTypes.number
    })
  }), PropTypes.shape({
    NomeOriginal: PropTypes.string,
    nomeOriginal: PropTypes.string,
    Tamanho: PropTypes.number,
    tamanho: PropTypes.number
  })]).isRequired,
  onRemove: PropTypes.func,
  onDownload: PropTypes.func,
  showRemove: PropTypes.bool,
  compact: PropTypes.bool
};
export default FilePreview; // Estilos baseados no padrão existente

const FilePreviewContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${props => props.compact ? '6px 10px' : '8px 12px'};
  border: 1px solid ${colorBorder};
  border-radius: 4px;
  background-color: ${colorHover};
  margin-bottom: ${props => props.compact ? '10px' : '20px'};
  width: 100%;
  cursor: ${props => props.clickable ? 'pointer' : 'default'};

  .file-info {
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 1;

    span {
      font-size: 14px;
      font-weight: 500;
      color: #333;
    }
  }
`;